export const SERVICE_URL = process.env.SERVICE_URL || '/api';
